import { ReorderableDndTable } from '@/components/basic';
import useSyncOrder from '@/hooks/useSyncOrder';
import { useToggle } from '@/hooks/useToggle';
import { External } from '@gettactic/api';
import { useMemo } from 'react';
import { Column } from 'react-table';

export interface IntegrationsExternalIdsTableViewProps {
  columns: Column<External>[];
  list: External[] | undefined;
  invalidateQuery: () => Promise<void>;
}

export function IntegrationsExternalIdsTableView({
  columns,
  list
}: IntegrationsExternalIdsTableViewProps) {
  const [, toggleCreateOpen] = useToggle(false);
  const tableColumns = useMemo<
    IntegrationsExternalIdsTableViewProps['columns']
  >(() => columns, [list, columns]);
  const {
    orderedList: tableData,
    keysInOrder,
    setKeysInOrder
  } = useSyncOrder<External>(list);

  return (
    <>
      <div className="flex flex-auto flex-col overflow-y-auto">
        <ReorderableDndTable
          weightScaleFactor={10}
          className="mt-2"
          reorderable={false}
          listItemsKeys={keysInOrder}
          setListItemsKeys={setKeysInOrder}
          updateFunction={async () => {}}
          tableColumns={tableColumns}
          tableData={tableData}
          tableId="table-HourRules"
          emptyActionCta={toggleCreateOpen}
          emptyDescription="You haven't added any external IDs yet."
          emptyAction="Start adding an external ID!"
        />
      </div>
    </>
  );
}
